import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Checkbox from './checkbox'
import { ajaxPatch } from '../../ajax'

const RegionsFilter = ({regions, states, excluded, onUpdate, onReload}) => {
  const [showMenu, setShowMenu] = useState(false)
  const [unchecked, setUnchecked] = useState(excluded)
  const [loading, setLoading] = useState(false)
  const dropdownRef = useRef()
  const buttonRef = useRef()
  const allIds = regions.map(r => r.id)
  const noChanges = excluded.sort().toString() == unchecked.sort().toString()

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (showMenu && dropdownRef.current && !dropdownRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
        setShowMenu(false)
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [showMenu])

  const onClickAll = (e) => {
    e.target.checked ? setUnchecked([]) : setUnchecked(allIds)
  }

  const onSelectTimezone = (checked, regionIds) => {
    var newUnchecked = unchecked
    regionIds.forEach(id => {
      if (checked) {
        unchecked.includes(id) && (newUnchecked = newUnchecked.filter(el => el != id))
      }
      else {
        !unchecked.includes(id) && (newUnchecked = newUnchecked.concat(id))
      }
    })
    setUnchecked(newUnchecked)
  }

  const onClickRegion = (e, region) => {
    e.target.checked ? setUnchecked(unchecked.filter(id => id !== region.id)) : setUnchecked(unchecked.concat(region.id))
  }

  const statesList = (list) => {
    const sortedStates = list.sort((a,b) => a.name.localeCompare(b.name))
    return sortedStates.map((state, index) => {
      const stateRegions = regions.filter(r => r.state == state.name)
      const stateCountry = stateRegions[0].country
      const stateName = state.name + (stateCountry == 'USA' ? '' : ` (${stateCountry})`)
      return <div className='state-regions' key={index}>
        <label className='region-label state-label'>{stateName}</label>
        { stateRegions.sort((a,b) => a.name.localeCompare(b.name)).map(region => 
            <Checkbox
              key={region.id}
              className='region-label state-region-label'
              label={region.name}
              checked={!unchecked.includes(region.id)}
              onChange={e => onClickRegion(e, region)}
            />
          )
        }
      </div>
    })
  }

  const regionsList = () => {
    const groupedStates = _.groupBy(states, state => state.timeshift)
    return Object.keys(groupedStates).map(group => {
      const firstState = groupedStates[group][0]
      const timezoneRegions = regions.filter(r => r.timeshift == firstState.timeshift)
      const timezoneRegionIds = timezoneRegions.map(sr => sr.id)
      const timezoneUnchecked = timezoneRegionIds.some(e => unchecked.includes(e))
      return <div className='timezone' key={group}>
        <Checkbox
          label={firstState.timezone}
          className='region-label timezone-label'
          checked={!timezoneUnchecked}
          onChange={e => onSelectTimezone(e.target.checked, timezoneRegionIds)}
        />
        {statesList(groupedStates[group])}
      </div>
    })
  }

  const onClickSave = async () => {
    setLoading(true)
    await updateRegions()
    onReload()
    setLoading(false)
  }

  const updateRegions = async () => {
    await ajaxPatch('/admins/regions_filter', { excluded_regions: unchecked.join(',') })
    onUpdate(unchecked)
  }

  return <div className='regions-filter'>
    <button className='filter-button' ref={buttonRef} onClick={() => setShowMenu(!showMenu)}>
      <i className='fa fa-globe'></i>Filter Regions
    </button>
    { showMenu && 
      <div className='regions-filter-menu' ref={dropdownRef}>
        { loading && <div className='animated-spinner'></div> }
        { loading && <div className='spinner-background'></div> }
        <div className='regions-list'>
          <Checkbox
            label='Select all'
            className='region-label timezone-label'
            checked={!unchecked.length}
            onChange={onClickAll}
          />
          { regionsList() }
        </div>
        <div className='list-bottom'>
          <button disabled={noChanges} onClick={onClickSave}>Save</button>
        </div>
      </div>
    }
  </div>
}

RegionsFilter.propTypes = {
  regions: PropTypes.array.isRequired,
  states: PropTypes.array.isRequired,
  excluded: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
}

export default RegionsFilter
